<template>
  <div class="p-box">
    <div class="p-box__header">
      <h3 class="p-box__title">
        {{ $t('pages.CompaniesLocationStore.service.servicePattern.categoryLabel', { value: category.name }) }}
      </h3>
    </div>
    <div class="p-box__body">
      <!-- servicePatternsがない場合 -->
      <template v-if="!servicePatterns.length">
        <p>
          {{ $t('pages.CompaniesLocationStore.service.noServicePatterns.content') }}
          <router-link
            v-if="showOnlyOwnerAuthority"
            :to="{ name: 'CompaniesServicesNew', params: { company_uuid: companyUuid, category_id: category.gmbCategoryId } }"
            class="noServicePatterns__link"
            v-text="$t('pages.CompaniesLocationStore.service.noServicePatterns.link')"
          />
        </p>
      </template>
      <template v-else>
        <!-- 連携エラー -->
        <template v-if="storeServicePattern && storeServicePattern.status === 'error'">
          <p class="errorTitle">{{ $t('pages.CompaniesLocationStore.service.error.title') }}</p>
          <Info alert>
            <p>{{ $t('pages.CompaniesLocationStore.service.error.info1') }}</p><br>
            <p>{{ $t('pages.CompaniesLocationStore.service.error.info2') }}</p>
          </Info>
        </template>
        <p class="u-fwB">{{ $t('pages.CompaniesLocationStore.service.select.label') }}</p>
        <!-- owner権限 -->
        <div v-if="showOnlyOwnerAuthority" class="c-select">
          <select :value="selectedServicePatternId" @change="handleSelectServicePattern">
            <option v-if="!selectedServicePattern" :value="null">{{ $t('labels.placeholder.select') }}</option>
            <option v-for="(servicePattern, key) in servicePatterns" :key="key" :value="servicePattern.id">
              {{ servicePattern.name }}
            </option>
          </select>
        </div>
        <!-- owner権限以外 -->
        <div v-else class="servicePattern__name">
          <template v-if="selectedServicePattern">
            <p class="u-fwB">{{ selectedServicePattern.name }}</p>
          </template>
          <template v-else>
            {{ $t('pages.CompaniesLocationStore.service.noSelectedServicePattern.content') }}
          </template>
        </div>
        <!-- サービス一覧 -->
        <template v-if="selectedServicePattern">
          <div
            v-for="(serviceItem, index) in selectedServicePattern.serviceItems"
            :key="`section-item-${index}`"
            class="p-box serviceItem"
          >
            <div class="p-box__body">
              <div class="serviceItem__content">
                <div class="serviceItem__content--above">
                  <div>{{ serviceItem.name }}</div>
                  <div v-if="serviceItem.price">
                    <span v-if="serviceItem.price.price">
                      {{ $t('labels.currency.yen', { number: numberLocaleString(serviceItem.price.price) }) }}
                    </span>
                    <span v-else>
                      {{ $t('labels.price.free') }}
                    </span>
                  </div>
                </div>
                <div class="serviceItem__content--bottom">{{ serviceItem.description }}</div>
              </div>
            </div>
          </div>
        </template>
        <div v-if="selectedServicePattern && showOnlyOwnerAuthority" class="c-button c-button--right">
          <button class="c-button__item c-button__item--primary" @click="handleUpdateStoreServicePattern">{{ $t('labels.save') }}</button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>


import Info from '../../Info'
import { toNumberLocaleString } from '../../../modules/localeString'

export default {
  name: 'CompaniesLocationStoreServicePattern',
  components: {
    Info
  },
  props: {
    category: {
      type: Object,
    },
    storeServicePattern: {
      type: Object,
    },
    showOnlyOwnerAuthority: {
      type: Boolean,
      default: false
    },
  },
  emits: ['update-store-service-pattern'],
  data() {
    return {
      selectedServicePatternId: this.storeServicePattern?.servicePatternId,
    }
  },
  computed: {
    servicePatternOptions() {
      return this.servicePatterns.filter(v => (v.id !== this.selectedServicePatternId))
    },
    selectedServicePattern() {
      return this.servicePatterns.find(s => s.id === this.selectedServicePatternId)
    },
    companyUuid() { return this.$route.params.company_uuid },
    servicePatterns() { return this.category.servicePatterns }
  },
  methods: {
    handleSelectServicePattern(e) {
      this.selectedServicePatternId = Number(e.target.value)
    },
    handleUpdateStoreServicePattern() {
      this.$emit('update-store-service-pattern', this.selectedServicePatternId)
    },
    /**
     * 数値の3桁区切り
     * @param  { Number } value
     * @return { Number }
     */
    numberLocaleString(value) {
      return toNumberLocaleString(value)
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../stylesheets/biz_spa/foundation/_var.scss';

.serviceItem {
  &__content {
    width: 100%;
    padding-right: 30px;

    &--above {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      font-weight: 700;
    }

    &--bottom {
      color: #9c9c9c;
    }
  }
}

.servicePattern {
  &__name {
    margin-top: 8px;
  }
}

.errorTitle {
  font-weight: 700;
  color: $color-accent-primary;
  padding-bottom: 16px;
}

.noServicePatterns {
  &__link {
    color: $color-accent-primary;
  }
}
</style>
